import JSZip from 'jszip';
export const getUa = () => {
    let platform: any = {}
    let ua: string = ''
    const MAP_EXP = {
        Weixin: /micromessenger/i,
        Mac: /(mac os x)\s+([\w_]+)/,
        Windows: /(windows nt)\s+([\w.]+)/,
        Ios: /(i(?:pad|phone|pod))(?:.*)cpu(?: i(?:pad|phone|pod))? os (\d+(?:[\.|_]\d+){1,})/,
        Android: /(android)\s+([\d.]+)/,
        Ipad: /(ipad).*os\s([\d_]+)/,
        Iphone: /(iphone\sos)\s([\d_]+)/,
    };
    for (let key in MAP_EXP) {
        const uaMatch = navigator.userAgent.toLowerCase().match(MAP_EXP[key]);
        platform[`is${key}`] = !!uaMatch;
        if (!!uaMatch) ua = key
        if (!!uaMatch && !platform.version) {
            platform.version = key === 'Ios' ? uaMatch[2].replace(/_/g, '.') : uaMatch[2];
        }
    }
    return {
        ua
    }
}

export const isMobile = () => {
  const ua = navigator.userAgent;
  const mobileRegex = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|windows phone|phone|webos|kindle|tablet/i;
  return mobileRegex.test(ua.toLowerCase());
};

const MATCH_BASE64 = /^data:\w+\/\w+(\+\w+)?;base64,/;
export const isBase64 = (str: string) => str && typeof str === 'string' && MATCH_BASE64.test(str);
interface sizeOption {
    width?: number;
    height?: number;
    quality?: number;
}
export const getSmallImage = (url: string, options: sizeOption) => {
    // 判断如果是base64直接return
    if (isBase64(url)) {
        return url;
    }
    const { width, height, quality } = options;
    if (url.indexOf('//') === 0) {
        url = 'https:' + url;
    } else if (url.indexOf('http') < 0 || url.indexOf('https') < 0) {
        url = 'https://' + url;
    }
    const urlObj = new URL(url);
    const newUrl = urlObj.origin + urlObj.pathname;
    let search;
    if (width) {
        search = `?x-oss-process=image/resize,w_${width},limit_0`;
    } else if (height) {
        search = `?x-oss-process=image/resize,h_${height},limit_0`;
    }
    if (quality) {
        if (!search) {
            search = `?x-oss-process=image/quality,Q_${quality}`;
        } else {
            search = search + `/quality,q_${quality}`;
        }
    }
    return newUrl + search;
};
export const fontClassified = (res: any) => {
    let fontFamilyList = [];
    let fontsList: any = [];
    for (let k in res) {
        let obj: any = {
            key: k,
        };
        if (k == 'cn') {
            obj.tab = '中文';
            obj.hasClass = true;
            obj.classList = res[k].map((item) => {
                return {
                    ...item,
                    icon: '',
                    title: item.name,
                    value: item.name,
                };
            });
            res[k].forEach((item) => {
                item.typeface.forEach((type) => {
                    fontsList.push({
                        ...type,
                        fontName: type.name,
                        name: type.post_script_name,
                        url: type.source_path,
                    });
                });
            });
        } else {
            obj.tab = '英文';
            obj.fontList = res[k];
            res[k].forEach((type) => {
                fontsList.push({
                    ...type,
                    fontName: type.name,
                    name: type.post_script_name,
                    url: type.source_path,
                });
            });
        }
        fontFamilyList.push(obj);
    }

    return {
        fontFamilyList,
        fontsList,
    };
};

/**
 * 拷贝文字到剪切板兼容方案
 * @param val
 * @returns void
 */
export const copyText = async (val: string) => {
    if (navigator.clipboard && navigator.permissions) {
        await navigator.clipboard.writeText(val);
    } else {
        const textArea = document.createElement('textArea') as HTMLTextAreaElement;
        textArea.value = val;
        textArea.style.width = '0';
        textArea.style.position = 'fixed';
        textArea.style.left = '-999px';
        textArea.style.top = '10px';
        textArea.setAttribute('readonly', 'readonly');
        document.body.appendChild(textArea);

        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
    }
};
/**
* 获取当前元素相对网页的位置
* @param element
* @returns {x, y}
*/
export const getElementPagePosition = (element: HTMLElement) => {
    if (element.getBoundingClientRect) {
        const { x, y } = element.getBoundingClientRect();
        return { x, y };
    }
    let actualLeft = element.offsetLeft;
    let actualTop = element.offsetTop;
    let current = element.offsetParent as HTMLElement;
    while (current !== null) {
        actualLeft += current.offsetLeft;
        actualTop += current.offsetTop + current.clientTop;
        current = current.offsetParent as HTMLElement;
    }
    return { x: actualLeft, y: actualTop };
};

/**
 * 判断当前元素是否是HTML元素
 * @param node
 * @returns boolean
 */
export const isHTMLNode = (node) => {
    const d = document.createElement('div');
    try {
        d.appendChild(node.cloneNode(true));
        return node.nodeType == 1;
    } catch (e) {
        return false;
    }
};


// 元素拖动
export const useEleDraggable = (
    el: string | HTMLElement,
    options: {
        handle: string | HTMLElement;
        offset: number; // x轴和y轴超出时，最小保留宽度
    },
) => {
    let { handle, offset = 30 } = options;

    if (typeof el === 'string') {
        const query = el;
        el = document.querySelector(query) as HTMLElement;
    }
    if (!handle) {
        handle = el;
    } else if (handle && typeof handle === 'string') {
        handle = document.querySelector(handle) as HTMLElement;
    }

    if (!isHTMLNode(el) || !isHTMLNode(handle)) {
        console.log('找不到HTML结点');
        return;
    }

    // 拖动状态
    let isDraging = false;
    // 开始时位置坐标
    let startPosition = [0, 0];
    // 元素初始位置
    let originStyle = [0, 0];
    const minX = offset - el.clientWidth;
    const maxX = document.body.clientWidth - offset;
    const minY = 0;
    const maxY = document.body.clientHeight - offset;

    const startDrag = (e) => {
        isDraging = true;
        // 重置样式
        const { x, y } = getElementPagePosition(el as HTMLElement);
        (el as HTMLElement).style.position = 'fixed';
        (el as HTMLElement).style.left = `${x}px`;
        (el as HTMLElement).style.top = `${y}px`;

        originStyle = [x, y];

        const { clientX, clientY } = e;
        startPosition = [clientX, clientY];

        window.addEventListener('mousemove', move);
    };

    const cancleDrag = () => {
        isDraging = false;
        window.removeEventListener('mousemove', move);
    };

    const move = (e) => {
        requestAnimationFrame(() => {
            if (isDraging) {
                const { clientX, clientY } = e;
                const moveX = clientX - startPosition[0];
                const moveY = clientY - startPosition[1];
                const [originLeft, originTop] = originStyle;
                let newX = originLeft + moveX;
                let newY = originTop + moveY;
                if (newX < minX) newX = minX;
                if (newY < minY) newY = minY;
                if (newX > maxX) newX = maxX;
                if (newY > maxY) newY = maxY;
                (el as HTMLElement).style.left = `${newX}px`;
                (el as HTMLElement).style.top = `${newY}px`;
            }
        });
    };

    (handle as HTMLElement).addEventListener('mousedown', startDrag);
    window.addEventListener('mouseup', cancleDrag);

    // 取消事件监听
    const destroy = () => {
        (handle as HTMLElement).removeEventListener('mousedown', startDrag);
        window.removeEventListener('mouseup', cancleDrag);
        console.log('draggable destroyed')
    };

    return { destroy };
};
export enum OrderPlace {
    Water,
    Download,
    Template,
}
export const getOrderType = (place: OrderPlace, type: string) => {
    if (type) {
        if (type == 'ai') {
            switch (place) {
                case OrderPlace.Water:
                    return 48;
                case OrderPlace.Download:
                    return 49;
                case OrderPlace.Template:
                    return 50;
            }
        } else if (type == 'template') {
            switch (place) {
                case OrderPlace.Water:
                    return 51;
                case OrderPlace.Download:
                    return 52;
                case OrderPlace.Template:
                    return 53;
            }
        }
    } else {
        return 44;
    }
};

export interface IImageProps {
    url: string;
    editorName?: string
}

// 图片下载
export const downloadImage = (props: IImageProps) => {
    const { url, editorName = '未命名' } = props
    // 将链接地址字符内容转变成blob地址, 解决图片下载直接打开问题
    // url 为图片地址
    fetch(url)
        .then(async (res) => await res.blob())
        .then((blob) => {
            // 创建隐藏的可下载链接
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = URL.createObjectURL(blob);
            // 保存下来的文件名
            a.download = editorName;
            document.body.appendChild(a);
            a.click();
            // 移除元素
            document.body.removeChild(a);
        })
};

/**
 *
 * @param imgWidth 图片宽度
 * @param imgHeight 图片高度
 * @param containerWidth 容器宽度
 * @param containerHeight 容器高度
 */
const getImageScaling = (
    imgWidth: number,
    imgHeight: number,
    containerWidth: number,
    containerHeight: number,
) => {
    let tempWidth = 0,
        tempHeight = 0;
    //原图片宽高比例 大于 指定的宽高比例，这就说明了原图片的宽度必然 > 高度
    if (imgWidth / imgHeight >= containerWidth / containerHeight) {
        if (imgWidth > containerWidth) {
            tempWidth = containerWidth;
            // 按原图片的比例进行缩放
            tempHeight = (imgHeight * containerWidth) / imgWidth;
        } else {
            // 按照图片的大小进行缩放
            tempWidth = imgWidth;
            tempHeight = imgHeight;
        }
    } else {
        // 原图片的高度必然 > 宽度
        if (imgHeight > containerHeight) {
            tempHeight = containerHeight;
            // 按原图片的比例进行缩放
            tempWidth = (imgWidth * containerHeight) / imgHeight;
        } else {
            // 按原图片的大小进行缩放
            tempWidth = imgWidth;
            tempHeight = imgHeight;
        }
    }
    return { tempWidth, tempHeight };
};
export const useAddSize = (baseWidth: number, baseHeight: number) => {

    const baseScale = 0.5;

    const getRenderWidth = ({ width, height }: { width: number; height: number }): number => {
        return getImageScaling(
            width,
            height,
            baseWidth * baseScale,
            baseHeight * baseScale,
        ).tempWidth;
    };

    const getRenderHeight = ({ width, height }: { width: number; height: number }): number => {
        return getImageScaling(
            width,
            height,
            baseWidth * baseScale,
            baseHeight * baseScale,
        ).tempHeight;
    };

    return {
        getRenderWidth,
        getRenderHeight,
    };
};
/**
* 下载blob类型数据
* @param {*} data
* @param {*} filename
*/
export function downloadBlobData(blob: Blob, filename: string) {
    if (!(blob instanceof Blob)) return;

    const blobURL = window.URL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename || `${Date.now()}.png`);
    if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
}
export enum ClickEvent {
    // 首页:开始生成
    HomePageGenerate = 1,
    // 生成页:生成页生成PPT
    CreatePageGenerate = 2,
    // 生成页:点击编辑
    CreatePageToEdit = 3,
    // 生成页:上面重新生成
    CreatePageCreateAll = 4,
    // 生成页:下面重新生成PPT
    CreatePageCreatePPT = 5,
    // 生成页: 分享领VIP
    CreatePageShareVIP = 6,
    // 首页:成为VIP
    HomePageVip = 7,
    // 生成页:成为VIP
    CreatePageVip = 8,
    // 生成页:导入大纲
    CreatePageImport = 9,
    // 生成页:导入大纲上传作品
    CreatePageImportUpload = 10,
    // 生成页:导入大纲付费
    CreatePageImportVip = 11,
    // 生成页:历史大纲
    CreatePageHistory = 12,
    // 编辑器：下载弹窗打开
    EditorOpenDownload = 13,
    // 编辑器:点击下载
    EditorDownload = 14,
    // PPT模板案例页发起裂变
    TemplateShare = 15,
}

export function isChrome() {  
    var userAgent = navigator.userAgent;  
    return userAgent.indexOf("Chrome") !== -1;  
}
let downloadOssState1 = false;

export const downloadOssByMergeImages = async(props:any) => {//下载长图
    if(downloadOssState1){
        return
    }
    downloadOssState1 = true;
    const { file_url, file_name = '未命名.png' } = props;
    let type = '';
    if(typeof file_url === 'object'&&file_url.length){
        type = file_url[0].split('.').slice(-1)[0];
        if(!type){
            return
        }
        // 加载所有图片
        const images = await Promise.all(file_url.map(url => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = 'Anonymous';
                img.onload = () => resolve(img);
                img.onerror = reject;
                img.src = url;
            });
        }));
        // 计算画布尺寸
        let totalHeight = 0;
        let maxWidth = 0;
        images.forEach(img => {
            totalHeight += img.height;
            maxWidth = Math.max(maxWidth, img.width);
        });
        // 创建画布
        const canvas = document.createElement('canvas');
        canvas.width = maxWidth;
        canvas.height = totalHeight;
        const ctx = canvas.getContext('2d');
        // 拼接图片
        let currentY = 0;
        images.forEach(img => {
            ctx.drawImage(img, 0, currentY);
            currentY += img.height;
        });
       const blob =  await  new Promise(resolve => {
            canvas.toBlob(blob => {
                resolve(blob);
            }, 'image/'+type);
        });
        // 创建隐藏的可下载链接
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = URL.createObjectURL(blob);
        // 保存下来的文件名
        a.download = file_name.split('.').slice(0,-1).join('.')+'.'+type;
        document.body.appendChild(a);
        a.click();
        // 移除元素
        document.body.removeChild(a);
        downloadOssState1 = false;
    }
    
};

let downloadOssState = false;

export const downloadOss = (props:any) => {//支持单个或者多个文件
    if(downloadOssState){
        return
    }
    downloadOssState = true;
    const { file_url, file_name = '未命名.docx' } = props
    if(typeof file_url === 'object'&&file_url.length){
        let arr = file_name.split('.');
        let name = arr.slice(0,-1).join('.');
        let type = arr.slice(-1)[0];
        const zip = new JSZip();
        let folder = zip.folder('files');
        let num = -1;
        Promise.resolve().then(() => {
            return file_url.reduce((accumulator:any, ossurl:string) => {
                return accumulator.then(() => fetch(ossurl)
                                .then(resp => resp.blob())
                                .then(blob => {
                                    num++;
                                    return folder.file(name+'_'+num+'.'+type, blob)})
                )
            }, Promise.resolve())
        }).then(() => {
            folder.generateAsync({type: "blob"}).then((blob:any) => {
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = URL.createObjectURL(blob);
                a.download = name+'.zip';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                downloadOssState = false;
            });
        })
    }else{
        fetch(file_url)
        .then(async (res) => await res.blob())
        .then((blob) => {
            // 创建隐藏的可下载链接
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = URL.createObjectURL(blob);
            // 保存下来的文件名
            a.download = file_name;
            document.body.appendChild(a);
            a.click();
            // 移除元素
            document.body.removeChild(a);
            downloadOssState = false;
        })
    }
    
};